import { getPhysicalRing } from 'owa-config';

const REMINDER_PROCESOR_BASE_URL = 'https://outlook.office.com/ows/';
const REMINDER_PROCESOR_BASE_URL_GALLATIN = 'https://partner.outlook.cn/ows/';
const REMINDER_PROCESOR_BASE_URL_BLACKFOREST = 'https://outlook.office.de/ows/';
const REMINDER_PROCESOR_BASE_URL_ITAR = 'https://outlook.office365.us/ows/';

export default function getCallbackUrlBase(): string {
    switch (getPhysicalRing()) {
        case 'BlackForest':
            return REMINDER_PROCESOR_BASE_URL_BLACKFOREST;
        case 'Gallatin':
            return REMINDER_PROCESOR_BASE_URL_GALLATIN;
        case 'ITAR':
            return REMINDER_PROCESOR_BASE_URL_ITAR;
        default:
            return REMINDER_PROCESOR_BASE_URL;
    }
}
